<div class="d-flex ps-3 py-2 align-items-center header">
    <fa-icon class="me-2" [icon]="faInfoCircle" aria-hidden="true"></fa-icon>
    <div
        class="my-3 ms-1 me-2 cursor-pointer"
        translate="SIDEMENU_SECTION_PACE_INFORMATION_LABEL"
        (click)="toggleIsCollapsed()"
    ></div>
    <div class="col-1 my-3 ms-0 me-2 cursor-pointer" (click)="toggleIsCollapsed()">
        <fa-icon [icon]="isCollapsed ? faChevronDown : faChevronUp" aria-hidden="true"></fa-icon>
    </div>
</div>

<div
    class="pace-information-container"
    *ngIf="!isCollapsed"
    [ngClass]="{ collapsed: isCollapsed, expanded: !isCollapsed }"
>
    <table class="table table-condensed borderless">
        <tbody>
            <tr *ngIf="!isPaceOnlineUser">
                <th translate="FREQUENT_ACTIVITIES_FOOTER_LAST_SYNC"></th>
                <td>{{ getLastSync() }}</td>
            </tr>
            <tr>
                <th translate="FREQUENT_ACTIVITIES_FOOTER_ENVIRONMENT"></th>
                <td>{{ strings.environment }}</td>
            </tr>
            <tr *ngIf="!isPaceOnlineUser">
                <th translate="FREQUENT_ACTIVITIES_FOOTER_BACKEND"></th>
                <td>{{ strings.targetBackend }}</td>
            </tr>
            <tr>
                <th translate="FREQUENT_ACTIVITIES_FOOTER_SALESORG"></th>
                <td>{{ strings.salesOrg }}</td>
            </tr>
            <tr>
                <th translate="FREQUENT_ACTIVITIES_FOOTER_PLANT"></th>
                <td>{{ strings.plant }}</td>
            </tr>
            <tr>
                <th translate="FREQUENT_ACTIVITIES_FOOTER_DESCRIPTION"></th>
                <td>{{ strings.plantSalesOrgDescription }}</td>
            </tr>
            <tr>
                <th translate="FREQUENT_ACTIVITIES_FOOTER_APP_VERSION"></th>
                <td>{{ strings.appVersion }}</td>
            </tr>
            <tr>
                <th></th>
                <td class="d-flex justify-content-end">
                    <button class="btn btn-primary" (click)="openChangelog()">
                        <fa-icon [icon]="faCodeBranch"></fa-icon> {{ 'SIDEMENU_BUTTON_CHANGELOG_LABEL' | translate }}
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>
